import script from "./NewProgramInSpireStep1View.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProgramInSpireStep1View.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__